import { useCallback } from 'react'
import { useState, useRef, useEffect } from 'react';
import { User } from 'lucide-react';
import styles from './partnerdropdown.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { fetchDataRequest, setPartnerCustomer, showSidebar, resetData } from '../../../redux/actions/actions';
import { useNavigate } from 'react-router-dom';

const useInfiniteScroll = (hasMore, loading, fetchMore) => {
  const observer = useRef();

  const lastElementRef = useCallback(node => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore && !loading) {
        fetchMore();
      }
    }, {
      root: null,
      rootMargin: '100px',
      threshold: 0.1
    });

    if (node) observer.current.observe(node);
  }, [loading, hasMore, fetchMore]);

  useEffect(() => {
    return () => {
      if (observer.current) observer.current.disconnect();
    };
  }, []);

  return lastElementRef;
};


const PartnerCustomerDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { dropdownItems, currentPage, hasMore, loading } = useSelector((state) => state.partner.partnerCustomer);
  const partnerCustomer = useSelector((state) => state.partner.partnerCustomer);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [customers, setCustomers] = useState([])
  const toggleDropdown = () => setOpen(prev => !prev);

  useEffect(() => {
    // Initial load
    dispatch(resetData())
    dispatch(fetchDataRequest(1));


  }, [dispatch]);


  const fetchMore = useCallback(() => {
    if (!loading && hasMore) {
      dispatch(fetchDataRequest(currentPage));
    }
  }, [dispatch, currentPage, loading, hasMore]);


  const lastElementRef = useInfiniteScroll(hasMore, loading, fetchMore);
  const handleSelect = (customer) => {
    setSelectedCustomer(customer.name);
    setOpen(false);

    dispatch(setPartnerCustomer({
      name: customer.name,
      customerId: customer.id
    }));
    dispatch(showSidebar());
    navigate('/dashboard')
  };
  useEffect(() => {
    setCustomers(dropdownItems)
    setSelectedCustomer(partnerCustomer.name)
  }, [dropdownItems, partnerCustomer])
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={styles.dropdown} ref={dropdownRef}>
      <button className={styles.dropdownToggle} onClick={toggleDropdown}>
        <span className={styles.icon}> <User className={styles.userIcon} /></span>
        <span className={styles.selectedItem}>{selectedCustomer}</span>
        <span className={styles.arrow}>▾</span>
      </button>
      {open && (
        <ul className={styles.dropdownMenu}>
          {customers.map((customer, idx) => (
            <li
              key={idx}
              className={`${styles.dropdownItem} ${selectedCustomer === customer.name ? styles.selectedItemInMenu : ''}`}

              onClick={() => handleSelect(customer)}
            >
              {customer.name}
            </li>
          ))}
          {hasMore && (
            <div
              ref={lastElementRef}
              className={`${styles.dropdownItem}`}
              style={{

                textAlign: "left",
              }}
            >
              {loading ? "Loading..." : "Loading..."}
            </div>
          )}
        </ul>
      )}
    </div>
  );
}
export default PartnerCustomerDropdown